<template>
  <div class="stripe-form-container">
    <!-- <div ref="card"></div> -->
    <b-row class="" v-if="card_error"
      ><b-col>
        <!-- <div id="card-error" class="my-3">
          <p class="error_validation_message_p_dy">{{ card_error }}</p>
        </div> -->
        <b-alert
          variant="danger"
          :class="{
            'alert-danger-dy': client_name == 'DY',
            'alert-danger-doorder': client_name == 'Doorder',
          }"
          :show="card_error != null"
          >{{ card_error }}
        </b-alert>
      </b-col></b-row
    >
    <!-- <b-row class="my-3">
      <b-col md="12">
        <b-form-group id="card-name-input-group" class="pb-0">
          <b-form-input
            class="form-control-auth"
            v-bind:class="{
              'form-control-auth-mid': client_name == 'MID',
              'form-control-auth-doom-yoga': client_name == 'DY',
              'form-control-doorder': client_name == 'Doorder',
            }"
            id="card_name_holder"
            v-model="card_name_holder"
            type="text"
            placeholder="Card Name Holder"
            required
          ></b-form-input> </b-form-group></b-col
    ></b-row> -->
    <!-- <label>Card Number</label> -->

    <b-row v-if="require_card == 'true' || this.require_card == true">
      <b-col sm="12" class="mb-1">
        <b-form-group
          :class="form_group_class"
          label="IBAN"
          :label-class="display_label ? '' : 'd-none'"
        >
          <div id="iban-element"></div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="require_card == 'true' || this.require_card == true">
      <b-col sm="12" class="mb-3">
        <p class="stripeIbanPDoorder">
          By providing your IBAN , you are authorizing us and Stripe, our
          payment service provider, to send instructions to your bank to debit
          your account and your bank to debit your account in accordance with
          those instructions. You are entitled to a refund from your bank under
          the terms and conditions of your agreement with your bank. A refund
          must be claimed within 8 weeks starting from the date on which your
          account was debited.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<!-- <script src="https://js.stripe.com/v3/"></script> -->

<script>
// let stripe = Stripe(
//     "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
//   ),
//   stripeElements = stripe.elements(),
// card = undefined;

// let options = {
// hidePostalCode: true,
// placeholder: "Card number",
// classes: elementClasses,

// };

import axios from "axios";
import $ from "jquery";

export default {
  name: "IBANStripeComponent",
  props: [
    "client_name",
    "require_card",
    "element_class_base",
    "display_label",
    "form_group_class",
    "stripe_token",
  ],
  data() {
    return {
      ibanElement: null,
      card_error: null,
      elementClasses: {
        base: "",
        focus: "focus",
        empty: "empty",
        invalid: "invalid",
      },
      style: {
        base: {
          color: "#6e6b7b",
          "::placeholder": {
            color: "#aaa",
          },
          fontWeight: "400",
          fontFamily: "Montserrat, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          lineHeight: "22px",
          // backgroundColor: "#393939",
          // color: "#fff",
          // "border-radius": "8px",
          // 'padding': "12px",

          // iconColor: "#c4f0ff",
          // fontWeight: "500",
          // fontFamily: "Futura LT",
          // fontSize: "16px",
          // fontSmoothing: "antialiased",
          // ":-webkit-autofill": {
          //   color: "#fce883",
          // },
        },

        invalid: {
          // All of the error styles go inside of here.
          // color: "#00ff00",
        },
      },
      stripe: null,
      stripeElements: null,
    };
  },
  mounted() {
    this.stripe = Stripe(
      "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
    );
    this.stripeElements = this.stripe.elements();

    this.elementClasses.base = this.element_class_base;

    if (this.client_name == "DY") {
      this.style.base.color = "#fff";
    }

    // console.log(options);
    // card = elements.create("card", options);
    // card.mount(this.$refs.card);
    console.log("in stripe components mounted ", this.require_card);
    if (this.require_card == "true" || this.require_card == true) {
      this.initCardForm();
    } else {
      if (this.ibanElement != null) {
        this.ibanElement.destroy();
      }
    }
  },
  updated() {
    this.stripe = Stripe(
      "pk_test_51HlxJsJs0xpQGogFbpLLfJQqWLrWGUQvzskO03ksiMewViQ9S4Dbmn9ON1hMNuoNLxuwC4EFkxjFAqiCbrD0NAwy00xU3OnBeN"
    );
    this.stripeElements = this.stripe.elements();

    console.log("in stripe components updated ", this.require_card);
    console.log(this.stripe_token);
    if (this.require_card == "true" || this.require_card == true) {
      this.initCardForm();
    } else {
      if (this.ibanElement != null) {
        this.ibanElement.destroy();
      }
    }
  },

  computed: {
    _stripe_token: {
      get() {
        return this.stripe_token;
      },
      set(value) {
        this.$emit("update:stripe_token", value);
      },
    },
  },
  methods: {
    initCardForm() {
      this.ibanElement = this.stripeElements.create("iban", {
        classes: this.elementClasses,
        style: this.style,
        supportedCountries: ["SEPA"],
      });
      this.ibanElement.mount("#iban-element");
      // options.placeholder = "MM / YY";
    },
    async purchase() {
      console.log("purchase ", this.ibanElement);
      let temp = this;
      await this.stripe.createToken(this.ibanElement).then(function (result) {
        // Access the token with result.token
        console.log(result);
        if (result.error != null) {
          // handle error here
          console.log(result.error);
          temp.card_error = result.error.message;
          return;
        } else {
          temp.card_error = null;
          temp.stripe_token = result.token.id;
          console.log(result.token.id);
          console.log(temp.stripe_token);
          console.log(temp._stripe_token);

          temp.$emit("update:stripe_token", result.token.id);
          // temp.$emit("stripe_token")
          // return temp.stripe_token
          // temp.submitPaymentForm();
          return result.token.id;
        }
      });
      //  const { token, error } = await stripe.createToken(this.cardNumber);
      // if (error) {
      //   // handle error here
      //   document.getElementById('card-error').innerHTML = error.message;
      //   return;
      // }
      // console.log(token);
    },
    submitPaymentForm() {
      alert(this.stripe_token);
    },
  },
  beforeDestroy() {
    // card.destroy(this.$refs.card);
    // console.log(this.cardNumber)
    // console.log(this.cardExpiry)
    // console.log(this.cardCvc)
    if (this.cardNumber != null) {
      this.cardNumber.destroy();
      this.cardExpiry.destroy();
      this.cardCvc.destroy();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/IBANStripeComponent.vue